import branchIO from "web/script/embedded/branch-io";
import environment from "web/script/modules/environment";
import globals from "web/script/modules/globals";
import {
    getBranchAnalyticsName,
    getLinkData,
    shouldSendAnalytics,
} from "web/script/utils/branch-io";
import url from "web/script/utils/url";

export default {
    send(data) {
        data.forEach((event) => {
            if (event.type === "page_view") {
                branchIO("init", environment.get("branchIoKey"), {
                    // metadata is used for targeting journeys in branch.io dashboard
                    metadata: {
                        trafficSource: getTrafficSource(),
                        lifeCycleStage: event.data.life_cycle_stage,
                        isReturningUser: event.data.returning_user,
                        country: event.data.country,
                        domain: event.data.domain,
                        page_type: event.data.page_type,
                        initial_page_type: event.data.initial_page_type,
                        user_id: event.data.user_id,
                    },
                });

                // Data that is passed through with click & view analytics
                branchIO("setBranchViewData", { data: getLinkData() });
            } else if (shouldSendAnalytics(event)) {
                return new Promise((resolve, reject) => {
                    branchIO("logEvent", getBranchAnalyticsName(event), null, function(err) {
                        if (err) {
                            reject(err);
                            return;
                        }
                        resolve();
                    });
                });
            }
        });
        // no way of waiting for this to be done
        return Promise.resolve();
    },
};

function getTrafficSource() {
    let params = url.parse(globals.window.location.href).searchParams;

    return params.get("atc_medium") == "cpc" || params.get("utm_medium") == "cpc"
        ? "paid"
        : "other";
}
